// extracted by mini-css-extract-plugin
export var back = "product-module--back--e5de3";
export var container = "product-module--container--52ed9";
export var footer = "product-module--footer--30483";
export var header = "product-module--header--0b8e4";
export var mainContainer = "product-module--mainContainer--c9ab8";
export var sliderContent = "product-module--sliderContent--6e285";